const REFERRAL_STORAGE_KEY = "ollacart_referral_code";

export function captureReferralFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = (params.get("ref") || "").trim().toUpperCase();
    if (ref) {
      localStorage.setItem(REFERRAL_STORAGE_KEY, ref);
    }
  } catch (_) {
    /* ignore */
  }
}

export function getStoredReferralCode() {
  try {
    return localStorage.getItem(REFERRAL_STORAGE_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function clearStoredReferralCode() {
  try {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch (_) {
    /* ignore */
  }
}
